import { BaseMediaFragment } from '@minecraft.graphql-operations';
import { captureHeapEvent, HEAP_EVENT_NAMES } from '@blocs.heap';

/**
 * Tracks an event to Braze with the summary of meidas uploaded
 */
export const trackMediaUploadEvent = ({
  location,
  organizationId,
  medias,
}: {
  location: string;
  organizationId: number;
  medias: Pick<BaseMediaFragment, 'size'>[];
}) => {
  try {
    if (!medias) return;

    let mediasAsArray = medias;
    if (!Array.isArray(medias)) {
      mediasAsArray = [medias];
    }
    captureHeapEvent({
      name: HEAP_EVENT_NAMES.REP_MEDIA_UPLOAD,
      data: {
        location,
        division: organizationId,
        fileCount: mediasAsArray?.length ?? 0,
        fileSize:
          mediasAsArray?.reduce((acc: number, curr: BaseMediaFragment) => acc + (curr.size as number) ?? 0, 0) ?? 0,
      },
    });
  } catch (err) {
    // Nom nom nom
  }
};
